// useToolApproval — FASE-11 E6-WS1-T02. Aprovação de ferramenta NÃO-bloqueante.
//
// Antes: o gate de tool mutante (permissions_mode='ask') usava window.confirm —
// modal NATIVO síncrono que CONGELA o renderer inteiro (streaming para, timers
// param, as outras sessões travam) até o clique (achado #13). Agora o
// requestApproval devolve uma Promise pendurada em estado React; o
// ApprovalPrompt (mesmo componente do dispatch mobile) renderiza inline no feed
// e o resto da UI segue vivo. O agent loop já era async — nada muda do lado dele.
//
// O hook devolve a UI PRONTA (`approvalUi`) — o SessionWorkspace (no teto do
// ratchet dp-loc) só interpola `{approvalUi}`, zero decision points novos.
//
// Segurança: desmontar com aprovação pendente resolve FALSE (deny) — o turno
// nunca fica pendurado esperando um dialog que não existe mais.

import { useCallback, useEffect, useRef, useState } from 'react';
import ApprovalPrompt from '../components/dispatch/ApprovalPrompt.jsx';

export function useToolApproval() {
  const [pending, setPending] = useState(null); // { desc } | null
  const resolveRef = useRef(null);

  const requestApproval = useCallback((desc) => new Promise((resolve) => {
    resolveRef.current = resolve;
    setPending({ desc });
  }), []);

  const decide = useCallback((approved) => {
    const resolve = resolveRef.current;
    resolveRef.current = null;
    setPending(null);
    if (resolve) resolve(!!approved);
  }, []);

  useEffect(() => () => {
    // unmount com pendência → deny explícito (nunca Promise órfã pendurada).
    if (resolveRef.current) { resolveRef.current(false); resolveRef.current = null; }
  }, []);

  const approvalUi = pending ? <ApprovalPrompt request={pending} onDecision={decide} /> : null;
  return { requestApproval, approvalUi };
}
